module.exports = "/_next/static/images/video_id_7110377527578725675-3f9f5d51c34cf567c9603f877e9a9b44.jpg";